import TransactionsPage from "@/pages/TransactionsPage";

export default function TransactionsIn() {
  return <TransactionsPage type="in" />;
}
